export default __webpack_public_path__ + "static/media/clear_grid_icon.4087cbff.svg";